module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/new_robot_icon.1fa82ced.png";